// eslint-disable-next-line
import { useState, useEffect } from 'react';
import styled from "styled-components";
import Select from "react-select";
// eslint-disable-next-line
import { CSSProperties } from 'react';

const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	width: fit-content;

	@media (max-width: 900px) {
		width: 100%;	
	}
`;

const Title = styled.p`
	margin: 0;
	min-width: fit-content;
	color: #f0f4ff;
	font-weight: 600;
	text-transform: none;
	font-size: 14px;
	letter-spacing: 0.3px;
`;

interface Option {
	label: string;
	value: string;
}

interface Props {
	selectedProperties: Option[] | null;
	onSelect: (options: Option[]) => void;
	properties: Option[];
}
const PropertySelect = (props: Props) => {
	const { onSelect, properties } = props;

	const allDefault: Option = { label: "All", value: "" };
	const [selectedProperties, setSelectedProperties] = useState<Option[]>([
		allDefault,
	]);

	useEffect(() => {
		onSelect([allDefault]);
	}, []);

	const handleSelect = (data: any) => {
		if (data) {
			setSelectedProperties(data);
			onSelect(data);
		} else {
			setSelectedProperties([]);
			onSelect([]);
		}
	};

	return (
		<Container>
			<Title>Property</Title>
				<Select
					value={selectedProperties}
					onChange={handleSelect}
					placeholder="Select property"
						styles={
							{
								container: (containerStyles: CSSProperties) => ({
									...containerStyles,
									width: 260,
									minHeight: 44,
								}),
								control: (selectStyles: CSSProperties, { isFocused }: any) => ({
									...selectStyles,
									background: "rgba(11, 19, 38, 0.95)",
									border: isFocused
										? "1px solid rgba(148, 163, 184, 0.5)"
										: "1px solid rgba(148, 163, 184, 0.25)",
									boxShadow: isFocused
										? "0 0 0 3px rgba(148, 163, 184, 0.2)"
										: "none",
									minHeight: 44,
									borderRadius: 12,
									padding: "0 8px",
									cursor: "pointer",
								}),
								valueContainer: (valueStyles: CSSProperties) => ({
									...valueStyles,
									padding: 0,
									color: "#f8fafc",
									fontWeight: 500,
								}),
								placeholder: (placeholderStyles: CSSProperties) => ({
									...placeholderStyles,
									color: "#94a3b8",
									textTransform: "none",
									letterSpacing: "0.2px",
									fontWeight: 500,
								}),
								singleValue: (singleValueStyles: CSSProperties) => ({
									...singleValueStyles,
									color: "#f8fafc",
									fontWeight: 600,
								}),
								multiValue: (multiStyles: CSSProperties) => ({
									...multiStyles,
									backgroundColor: "rgba(148, 163, 184, 0.2)",
									borderRadius: 10,
									border: "1px solid rgba(148, 163, 184, 0.35)",
								}),
								multiValueLabel: (labelStyles: CSSProperties) => ({
									...labelStyles,
									color: "#f8fafc",
									fontSize: 12,
									fontWeight: 600,
								}),
								multiValueRemove: (removeStyles: CSSProperties) => ({
									...removeStyles,
									color: "#94a3b8",
									":hover": {
										backgroundColor: "transparent",
										color: "#f8fafc",
									},
								}),
								menu: (menuStyles: CSSProperties) => ({
									...menuStyles,
									backgroundColor: "rgba(11, 19, 38, 0.98)",
									border: "1px solid rgba(148, 163, 184, 0.25)",
									boxShadow: "0 16px 34px rgba(0, 0, 0, 0.35)",
									borderRadius: 12,
									overflow: "hidden",
									marginTop: 8,
							}),
								menuList: (menuListStyles: CSSProperties) => ({
									...menuListStyles,
									padding: 8,
								}),
								option: (optionStyles: CSSProperties, { isFocused, isSelected }: any) => ({
									...optionStyles,
									backgroundColor: isSelected
										? "rgba(148, 163, 184, 0.25)"
										: isFocused
											? "rgba(148, 163, 184, 0.18)"
											: "transparent",
									color: "#f8fafc",
									cursor: "pointer",
									textTransform: "none",
									borderRadius: 8,
									padding: "10px 12px",
								}),
								indicatorSeparator: () => ({ display: "none" }),
								dropdownIndicator: (indicatorStyles: CSSProperties) => ({
									...indicatorStyles,
									color: "#94a3b8",
									padding: 0,
								}),
								clearIndicator: (indicatorStyles: CSSProperties) => ({
									...indicatorStyles,
									color: "#94a3b8",
									padding: 0,
								}),
							} as any
						}
					options={[allDefault, ...properties]}
					isMulti
					closeMenuOnSelect={false}
				/>

		</Container>
	);
};

export default PropertySelect;
